import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common'; // Importa CommonModule
import { TranslateModule } from '@ngx-translate/core';
import { DataService, Tracking, TrackingAggregato } from '../../services/business-data.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TrackingWaybill, TrackingParcel } from '../../services/data.service';


@Component({
  selector: 'app-tracking',
  standalone: true, // Rendi il componente standalone
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css'],
  imports: [FormsModule, CommonModule, TranslateModule], // Importa FormsModule qui

})


export class TrackingComponent {
  trackingCode: string = '';
  hasCode: boolean = false;
  isLoading: boolean = false;
  submitted: boolean = false;
  notFound: boolean = false;
  loadError: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) {}

  // Il componente è raggiungibile sia da /tracking (pubblico) che da /private/tracking (privato)
  private get basePath(): string {
    return this.router.url.startsWith('/private/') ? '/private/tracking' : '/tracking';
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const code = params.get('code');
      if (code && code.trim()) {
        this.trackingCode = code.trim();
        this.hasCode = true;
        this.loadTrackingData(this.trackingCode);
      } else if (code !== null) {
        // Parametro presente ma vuoto → not found immediato
        this.hasCode = true;
        this.notFound = true;
      }
    });
  }
  // Funzione per caricare i dati di tracking
  trackingData: Tracking[] = [];
  parcelData: TrackingParcel[] = [];
  waybillData: TrackingWaybill[] = [];

  loadTrackingData(code: string): void {
    if (!code || !code.trim()) {
      this.notFound = true;
      return;
    }
    this.http.get<Tracking[]>(`${environment.apiUrl}/tracking/${code}`).subscribe({
      next: (tracking: Tracking[]) => {
        this.trackingData = tracking;
      },
      error: (err) => {
        console.error('Errore durante la chiamata GET tracking:', err);
      }    });    this.http.get<TrackingParcel[]>(`${environment.apiUrl}/tracking/parcel/${code}`).subscribe({
      next: (parcel: TrackingParcel[]) => {        const uniqueParcels = parcel.filter(
          (p, index, self) =>
            index === self.findIndex(other => other.parcelCode === p.parcelCode)
        );
        this.parcelData = uniqueParcels;
      },
      error: (err) => {
        console.error('Errore durante la chiamata GET parcel:', err);
      }
    });

    this.http.get<TrackingWaybill[]>(`${environment.apiUrl}/tracking/waybill/${code}`).subscribe({
      next: (waybill: TrackingWaybill[]) => {
        this.waybillData = waybill;
        if (!waybill || waybill.length === 0) {
          this.notFound = true;
        }
      },
      error: (err) => {
        console.error('Errore durante la chiamata GET waybill:', err);
        this.loadError = true;
      }
    });
  }

  // Funzione per consentire solo lettere e numeri
  allowOnlyAlphanumeric(event: KeyboardEvent): void {
    const char = event.key;
    const isValid = /^[A-Za-z0-9]$/.test(char); // Controlla se il carattere è alfanumerico
    if (!isValid) {
      event.preventDefault(); // Impedisce l'inserimento di caratteri non validi
    }
  }

  // Get validation error message for tracking code
  getErrorMessage(): string {
    if (!this.submitted) return '';
    
    if (!this.trackingCode.trim()) {
      return 'TRACKING.INPUT.REQUIRED';
    }
    
    const isValid = /^[A-Za-z0-9]+$/.test(this.trackingCode.trim());
    if (!isValid) {
      return 'TRACKING.INPUT.INVALID';
    }
    
    return '';
  }

  // Check if input has error
  hasError(): boolean {
    return this.submitted && this.getErrorMessage() !== '';
  }

  resetSearch(): void {
    this.hasCode = false;
    this.notFound = false;
    this.loadError = false;
    this.trackingCode = '';
    this.submitted = false;
    this.router.navigate([this.basePath]);
  }

  redirectToTracking(): void {
    this.submitted = true;
    const cleanedCode = this.trackingCode.trim();
    const isValid = /^[A-Za-z0-9]+$/.test(cleanedCode);

    if (cleanedCode && isValid) {
      this.isLoading = true;
      
      // Simula un delay per mostrare l'animazione (aumentato a 2 secondi come recovery)
      setTimeout(() => {
        this.isLoading = false;
        this.router.navigate([`${this.basePath}/${cleanedCode}`]);
      }, 2000);
    }
  }
}
